import { render, staticRenderFns } from "./TestPreview.vue?vue&type=template&id=4b04e552&scoped=true"
import script from "./TestPreview.vue?vue&type=script&lang=js"
export * from "./TestPreview.vue?vue&type=script&lang=js"
import style0 from "./TestPreview.vue?vue&type=style&index=0&id=4b04e552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04e552",
  null
  
)

export default component.exports